import { Visibility, VisibilityOff } from '@mui/icons-material';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useForm } from 'react-hook-form';
const LoginForm = forwardRef((props, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    const { onSubmit } = props;
    const { register, handleSubmit, formState } = useForm({
        defaultValues: {
            email: '',
            password: '',
        },
    });
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    useImperativeHandle(ref, () => ({
        handleSubmitForm: () => {
            handleSubmit((data) => onSubmit({
                email: data.email,
                password: data.password,
            }))();
        },
    }));
    return (React.createElement("form", null,
        React.createElement(FormControl, { error: !!formState.errors.email, margin: 'normal', variant: 'outlined', fullWidth: true },
            React.createElement(InputLabel, { htmlFor: 'outlined-username' }, "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430"),
            React.createElement(OutlinedInput, Object.assign({ id: 'outlined-username', label: '\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430', fullWidth: true, placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0432\u043E\u044E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443' }, register('email', {
                required: true,
                setValueAs: (v) => (typeof v === 'string' ? v.trim() : v),
                pattern: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
            })))),
        React.createElement(FormControl, { error: !!formState.errors.password, margin: 'normal', variant: 'outlined', fullWidth: true },
            React.createElement(InputLabel, { htmlFor: 'outlined-adornment-password' }, "\u041F\u0430\u0440\u043E\u043B\u044C"),
            React.createElement(OutlinedInput, Object.assign({ id: 'outlined-adornment-password', type: showPassword ? 'text' : 'password', label: '\u041F\u0430\u0440\u043E\u043B\u044C', fullWidth: true, placeholder: '\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C', autoComplete: 'new-password', endAdornment: React.createElement(InputAdornment, { position: 'end' },
                    React.createElement(IconButton, { edge: 'end', "aria-label": 'toggle password visibility', onClick: handleClickShowPassword }, showPassword ? React.createElement(Visibility, { fontSize: 'small' }) : React.createElement(VisibilityOff, { fontSize: 'small' }))) }, register('password', {
                required: true,
                setValueAs: (v) => (typeof v === 'string' ? v.trim() : v),
            }))))));
});
export default LoginForm;
